import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export default function LoadingModal(props) {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} alignContent='center' alignItems='center' justifyItems='center' justifyContent='center'>
        <Typography
          id="modal-description"
          variant='h2'
          style={{color:"white"}}
        > 
          {'Loading....'}
        </Typography>
      </Box>
    </Modal>
  );
}
